import { useContext } from 'react';
import { AuthContext, type AuthState } from './AuthContext.ts';

export function useAuth(): AuthState {
  return useContext(AuthContext);
}
